import React from 'react';
import styled from 'styled-components';
import NoResultWithPreOpen from 'containers/IdentificationPage/SearchResults/NoResultWithPreOpen';
import messages from 'containers/IdentificationPage/messages';
import { translate } from 'containers/services/translate';
import { COLORS } from 'constants/design';
import { IntlShape, injectIntl } from 'react-intl';
import { SearchClaims } from 'containers/IdentificationPage/typings';
import {
  isClaimOpen,
  isClaimRejected,
} from 'containers/IdentificationPage/utils';
import { get } from 'lodash';

const SearchResultsContainer = styled.div`
  background: ${COLORS.WHITE} 0% 0% no-repeat padding-box;
  box-shadow: 0px 1px 3px #0000001f;
  border-radius: 4px;
  min-height: 230px;
  margin-top: 23px;
  overflow: auto;
  margin-top: 50px;
`;

const Title = styled.h4`
  text-transform: uppercase;
  padding: 24px;
  margin: 0;
`;

export interface SearchResultsProps {
  intl: IntlShape;
  policyExists: Boolean;
  claimExists: Boolean;
  searchClaim: SearchClaims;
  requestSupportDocuments: Function;
  listings: any;
  enablePreOpenClaim: boolean;
  isPreOpeningManager?: boolean;
  requestGetReportsPolicy: Function;
}

const SearchResults: React.FC<SearchResultsProps> = (props): JSX.Element => {
  const isRejected = isClaimRejected(props.searchClaim);
  const isOpen = isClaimOpen(props.listings, props.searchClaim);
  const policyNumber = get(props.searchClaim, 'sagis.policy.policyNumber');
  return (
    <SearchResultsContainer id="result">
      <Title>{translate({ ...messages.searchResultTitle }, props)}</Title>
      <NoResultWithPreOpen
        policyExists={props.policyExists}
        claimExists={props.claimExists}
        isRejected={isRejected}
        isOpen={isOpen}
        policyNumber={policyNumber}
        requestSupportDocuments={props.requestSupportDocuments}
        enablePreOpenClaim={props.enablePreOpenClaim}
        isPreOpeningManager={props.isPreOpeningManager}
        corporealClaim={get(props.searchClaim, 'corporeal', [])}
        listings={props.listings}
        requestGetReportsPolicy={props.requestGetReportsPolicy}
      />
    </SearchResultsContainer>
  );
};

export default injectIntl(SearchResults);
